export const fmtRM = (v) =>
  v === null || v === undefined || v === "" ? "—" :
  `RM${Number(v).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (v, d = 2) =>
  v === null || v === undefined || v === "" ? "—" :
  Number(v).toLocaleString("en-MY", { minimumFractionDigits: 0, maximumFractionDigits: d });

export const MONTHS = [
  "", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const monthLabel = (y, m) => `${MONTHS[Number(m)] || m} ${y}`;

export const BATCH_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  calculated: { label: "Calculated", cls: "bg-sky-50 text-sky-700 border-sky-300" },
  reviewed: { label: "Reviewed", cls: "bg-indigo-50 text-indigo-700 border-indigo-300" },
  shadow_finalized: { label: "Shadow Finalized · Locked", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  finalized: { label: "Finalized · Locked", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
};

export const RECON_STATUS = {
  pending: { label: "Pending", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  match: { label: "Match", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  difference_expected: { label: "Difference — Expected", cls: "bg-sky-50 text-sky-700 border-sky-300" },
  difference_requires_review: { label: "Difference — Requires Review", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  resolved: { label: "Resolved", cls: "bg-indigo-50 text-indigo-700 border-indigo-300" },
};

export const ATTENDANCE_CATEGORY = {
  present: "Present", paid_leave: "Approved Paid Leave", unpaid_leave: "Approved Unpaid Leave",
  public_holiday: "Public Holiday", off: "Weekly Off / Rotation Off",
  approved_exception: "Approved Exception", unresolved: "Unresolved",
};

export const COMPONENT_CATEGORIES = [
  { value: "earning", label: "Earning" },
  { value: "deduction", label: "Deduction" },
  { value: "statutory", label: "Statutory" },
];

export const AA_METHODS = [
  { value: "no_effect", label: "No Effect" },
  { value: "fixed_per_day", label: "Fixed Amount Per Day" },
  { value: "full_forfeit", label: "Full Forfeit" },
];

export const AA_HALF_METHODS = [
  { value: "unconfigured", label: "Unconfigured (flags review)" },
  { value: "no_effect", label: "No Effect" },
  { value: "fixed", label: "Fixed Half-Day Amount" },
  { value: "half_of_per_day", label: "Half of Per-Day Amount" },
];

export const RECON_FIELD_LABELS = {
  basic_salary: "Basic Salary", fixed_allowance: "Fixed Allowance", variable_allowance: "Variable Allowance",
  attendance_allowance: "Attendance Allowance", ul_deduction: "UL Deduction", gross_pay: "Gross Pay",
  epf_employee: "EPF (EE)", epf_employer: "EPF (ER)", socso_employee: "SOCSO (EE)", socso_employer: "SOCSO (ER)",
  eis_employee: "EIS (EE)", eis_employer: "EIS (ER)", pcb: "PCB", net_pay: "Net Pay",
};

export const READINESS_LABELS = {
  payroll_profiles_complete: "Payroll Profiles Complete",
  attendance_operational: "Attendance Operational",
  leave_operational: "Leave Operational",
  november_shadow_reviewed: "November Shadow Reviewed",
  december_shadow_reviewed: "December Shadow Reviewed",
  epf_validated: "EPF Validated",
  socso_validated: "SOCSO Validated",
  eis_validated: "EIS Validated",
  pcb_lhdn_production_validated: "PCB / LHDN Production Validated",
  material_differences_resolved: "Material Differences Resolved",
};
